import React from 'react'
import { Box, Typography } from "@mui/material"
import { IconSeeker } from "@ui-seeker/core"
import { truncateString } from "@utils"

export default function conditionNameColumn() {

	const iconMap = {
		"$": "money-bills",
		"%": "percent",
		"Decrease": "arrow-down",
		"Increase": "arrow-up",
		"Increase/Decrease": "arrow-down-arrow-up"
	}

	const colorMap = {
		"$": "success.dark",
		"%": "black",
		"Decrease": "error.main",
		"Increase": "success.main",
		"Increase/Decrease": "warning.main"
	}

	return {
		name: 'conditionName',
		label: 'Condition',
		options: {
			filter: false,
			customBodyRowRenderLite: (value, { comparatorName, comparatorUnitName, comparatorValue }) => <Box
				sx={{
					display: "flex",
					justifyContent: "center",
					alignItems: "center",
					flexDirection: "column"
				}}>
				<Typography fontWeight="bold">{truncateString(value, 8)}</Typography>
				<Box
					sx={{ display: "flex", justifyContent: "center", alignItems: 'center' }}>
					<Typography sx={{ fontWeight: "bold" }}>{comparatorValue}</Typography>
					<IconSeeker
						icon={iconMap[comparatorUnitName]}
						sx={{
							mx: .7,
							fontSize: 14,
							color: colorMap[comparatorUnitName]
						}}/>
					<IconSeeker
						tooltip={comparatorName}
						icon={iconMap[comparatorName]}
						sx={{
							fontSize: 14,
							color: colorMap[comparatorName]
						}}
					/>
				</Box>
			</Box>
		}
	}
}